export default __webpack_public_path__ + "static/media/A4.3a5c567e.mp3";